import { makeStyles } from '@material-ui/core/styles';
import { buttonIconStyle } from '../../shared/styles/buttons.styles';
import { redesignTheme } from '../../theme';
import { seriousGameShellStyles } from '../shell.styles';

const { colors, fonts, fontSize, spacing, radius, breakpoints } = redesignTheme;

export const useSeriousGamePlayStyles = makeStyles(() => ({
  ...seriousGameShellStyles,
  primaryButton: {
    ...seriousGameShellStyles.primaryButton,
    textAlign: 'center',
  },
  primaryButtonIcon: {
    ...buttonIconStyle,
  },
  progressBlock: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  progressMeta: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: spacing.sm,
    fontFamily: fonts.gothic,
    fontSize: fontSize.md,
    color: colors.primary,
    letterSpacing: 1.26,
    lineHeight: 1.2,
    textTransform: 'uppercase',
  },
  progressTrack: {
    height: 8,
    width: '100%',
    borderRadius: radius.sm,
    backgroundColor: 'rgba(0, 10, 141, 0.12)',
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    borderRadius: radius.sm,
    backgroundColor: colors.primary,
    transition: 'width 0.2s ease',
  },
  contentStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.lg,
  },
  richText: {
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: '#151528',
    lineHeight: 'normal',
    wordBreak: 'break-word',
    '& p, & h3': {
      margin: 0,
    },
    '& img': {
      maxWidth: '100%',
      height: 'auto',
    },
  },
  citation: {
    padding: spacing.md,
    borderLeft: `4px solid ${colors.primary}`,
    borderRadius: radius.sm,
    backgroundColor: colors.white,
    fontFamily: fonts.opensans,
    color: '#151528',
  },
  citationText: {
    margin: 0,
    fontSize: fontSize.base,
    fontFamily: fonts.opensansSemiBold,
    lineHeight: 1.6,
  },
  citationAuthor: {
    margin: `${spacing.xs}px 0 0`,
    fontSize: fontSize.md,
    fontFamily: fonts.opensansBold,
    color: colors.primaryDark,
  },
  encyclopedia: {
    padding: spacing.md,
    borderRadius: radius.sm,
    backgroundColor: colors.surface,
    border: `1px solid ${colors.surfaceBorder}`,
    fontFamily: fonts.opensans,
    fontSize: fontSize.md,
    color: '#151528',
    lineHeight: 1.6,
    '& p, & h3': {
      margin: 0,
    },
  },
  mediaBlock: {
    position: 'relative',
    width: '100%',
  },
  imageWrap: {
    position: 'relative',
    width: '100%',
    borderRadius: 5,
    overflow: 'hidden',
    backgroundColor: colors.progressTrackMuted,
  },
  zoomButton: {
    position: 'absolute',
    top: spacing.xs,
    right: spacing.xs,
    zIndex: 2,
    width: 36,
    height: 36,
    border: 0,
    borderRadius: '50%',
    backgroundColor: colors.primary,
    color: colors.white,
    cursor: 'pointer',
    fontFamily: fonts.opensans,
    fontSize: fontSize.lg,
    lineHeight: 1,
  },
  choices: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
  },
  choiceTitle: {
    margin: 0,
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.base,
    color: colors.primaryDark,
  },
  endMessage: {
    margin: 0,
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.base,
    color: colors.primaryDark,
    textAlign: 'center',
  },
  footer: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    padding: `20px 40px 40px`,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      padding: `${spacing.sm}px`,
    },
  },
  signupWrap: {
    maxWidth: 900,
    margin: '40px auto',
    padding: `0 ${spacing.sm}px`,
  },
}));
